import {Entity} from "../Entity";

export class TenantApplication implements Entity {
    id: string;
    tenantId: string;
    name: string;
    friendlyName?: string;

    constructor(id: string, tenantId: string, name: string, friendlyName?: string) {
        this.id = id;
        this.tenantId = tenantId;
        this.name = name;
        this.friendlyName = friendlyName;
    }
}
